import React, { useEffect } from 'react';
import { BrowserRouter, Redirect, Switch } from 'react-router-dom';

import AuthRoute from './AuthRoute';
import Book from './Book';
import NewContact from './NewContact';
import NewCourse from './NewCourse';
import NewExam from './NewExam';
import Dashboard from './Dashboard';
import DriverPolicy from './DriverPolicy';
import GeneralFaq from './GeneralFaq';
import NewDriverFaq from './NewDriverFaq';
import Layout from './Layout';
import Login from './Login';
import Logout from './Logout';
import MagicLogin from './MagicLogin';
import Parking from './Parking';
import NewProfile from './NewProfile';
import Report from './Report';
import Route from './ScrollToTopRoute';
import Uber from './Uber';
import Privacy from './Privacy';
import NewTerms from './Terms';
import NewApply from './NewApply';
import BankingInfo from '../components/Banking';
import HstNumber from '../components/Hst';
import NewBook from './NewBook';
import MyBookings from './MyBookings';
import NewDash from './NewDash';
import Promotion from './Promotion';
import LandingPage from './LandingPage';

import LandingPageNYC from './LandingPageNYC';
import GeoRouter from './GeoRouter';
import NewPayments from './NewPayments';
import PriceMap from './PriceMap';
import Password from './UpdatePassword';
import Connect from './Connect';
import Intro from './Intro';

// import ParkingAccess from "./ParkingAccess"; remember to import back when login is setup
// import About from '../components/Static/About';
import AutzuPlus from '../components/Static/TorontoFleets/AutzuPlus';
import AutzuGo from '../components/Static/NYCFleets/AutzuGo';
import AutzuPro from '../components/Static/TorontoFleets/AutzuPro';
import MobileLandingPage from '../components/Static/LandingPage/MobileLandingPage';
// import Careers from '../components/Static/Careers';
import Careers from '../components/Careers/index';
import AutzuEv from '../components/Static/TorontoFleets/AutzuEV';
import AutzuEvSF from '../components/Static/SFFleets/AutzuEVSF';
import ForgotPass from '../components/User/ForgotPass';
import Invite from '../components/Referral/Invite';
import MissingDocs from '../components/MissingDocs';
import PaymentFaq from '../components/Static/PaymentFaq';
import ChangesFaq from '../components/Static/ChangesFaq';
import ChangesFaqMobile from '../components/Static/ChangesFaqMobile';
import NycDmvIssue from '../components/Static/NycDmvIssue';
import Referral from '../components/Referral';
import ResetPass from '../components/User/ResetPass';
import SmsVerification from '../components/User/SmsVerification';
import UberToronto from '../components/Static/UberToronto';

import NewSignUp from './NewSignUp';
import NoMatch from './NoMatch';
import LandingPageSF from '../components/Static/LandingPageSF';
import PrivacyTOR from '../components/Static/NewPrivacy';
import NewPrivacy from '../components/Static/NewPrivacy';
import GeoRouterSignup from './GeoRouterSignup';
import LandingPageLA from '../components/Static/LandingPageLA';
import GeoRouterDownload from '../components/GeoRouter/download';
import SignUpEmail from '../components/NewSignUp/SignUpEmail';
import SignUpCallRequest from '../components/NewSignUp/SignUpCallRequest';
import GeoRouterSignIn from './GeoRouterSignIn';
import ContactEmail from '../components/NewContact/ContactEmail';
import ContactCallRequest from '../components/NewContact/ContactCallRequest';
import DownloadApp from '../components/NewSignUp/DownloadApp';
import GreenLightHubRouter from './GreenLightHubRouter';
import Newsroom from '../components/Newsroom';
import AboutUs from '../components/Newsroom/AboutUs';
import GoalVision from '../components/Newsroom/GoalVision';
import AllArticles from '../components/Newsroom/AllArticles';
import MediaKit from '../components/Newsroom/MediaKit';
import KingInstructions from '../components/Static/ParkingLots/Toronto/KingInstructions';
import BloorInstructions from '../components/Static/ParkingLots/Toronto/BloorInstructions';
import EmbarcaderoInstructions from '../components/Static/ParkingLots/SF/EmbarcaderoInstructions';
import DriverFaq from '../components/Static/DriverFaq';
import DriverFaqRouter from '../components/DriverFaqRouter';
import LandingPageOTT from '../components/Static/LandingPageOTT';
import ByWardInstructions from '../components/Static/ParkingLots/Ottawa/ByWardInstructions';
import PitchDeck2024 from '../components/PitchDeck/PitchDeck2024';
import Investors from '../components/Investors';
import AutzuVideo from '../components/Videos';
import GeoRouterVideo from './GeoRouterVideo';
import Blogs from '../components/Blogs';
import BlogPage from '../components/Blogs/BlogPage';
import CreateBlog from '../components/Blogs/NewBlog/CreateBlog';
import EditBlogIndex from '../components/Blogs/EditBlog';
import AccountPage from '../components/Account';
import GeoRouterSingleVideo from './GeoRouterSingleVideo';
import NewSignOut from '../components/User/NewSignOut';
import SomaInstructions from '../components/Static/ParkingLots/SF/SomaInstructions';

const Root = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/logout" exact component={Logout} />
      <Route path="/signout" exact component={NewSignOut} />
      <Route path="/forgot" exact component={ForgotPass} />
      <Route path="/reset" exact component={ResetPass} />
      <Route path="/uber" exact component={Uber} />
      <Route path="/plushtml" exact component={AutzuPlus} />
      <Route
        path="/changesFAQMobile"
        exact
        component={ChangesFaqMobile}
        onUpdate={() => window.scrollTo(0, 0)}
      />
      <Route path="/tor/dfaq" exact component={DriverFaqRouter} />
      <Route path="/sf/dfaq" exact component={DriverFaqRouter} />
      <Route path="/ott/dfaq" exact component={DriverFaqRouter} />
      <Route
        path="/tor/downtown/parkinginstructions"
        exact
        component={KingInstructions}
      />
      <Route
        path="/tor/bloor/parkinginstructions"
        exact
        component={BloorInstructions}
      />
      <Route
        path="/sf/embarcadero/parkinginstructions"
        exact
        component={EmbarcaderoInstructions}
      />
      <Route
        path="/sf/soma/parkinginstructions"
        exact
        component={SomaInstructions}
      />
      <Route
        path="/ott/byward/parkinginstructions"
        exact
        component={ByWardInstructions}
      />
      <Route path="/privacy" exact component={GeoRouter} />
      <Route path="/:region/privacy" exact component={NewPrivacy} />
      <Route path="/terms" exact component={GeoRouter} />
      <Route path="/:region/terms" exact component={NewTerms} />
      <AuthRoute path="/introapp/:id" exact component={Intro} />
      <AuthRoute path="/rls" exact component={DriverPolicy} />
      <AuthRoute path="/coursehtml" exact component={NewCourse} />
      <AuthRoute path="/examhtml" exact component={NewExam} />
      <Route path="/" exact component={GeoRouter} />
      <Route path="/tor/uberglh" exact component={GreenLightHubRouter} />
      {/* <Route
        path="/pitchdeck2024CN/short"
        exact
        component={PitchDeck2024}
      />
      <Route
        path="/pitchdeck2024CN/full"
        exact
        component={PitchDeck2024}
      /> */}
      <Layout>
        <Switch>
          <Route path="/login" exact component={GeoRouterSignIn} />
          <Route
            path="/signup"
            exact
            component={GeoRouterSignup}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/signup/download"
            exact
            component={DownloadApp}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/signup/email"
            exact
            component={SignUpEmail}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/signup/call"
            exact
            component={SignUpCallRequest}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route path="/account" exact component={GeoRouterSignIn} />
          <Route path="/download" exact component={GeoRouterDownload} />
          <Route path="/nyc" exact component={LandingPageNYC} />
          <Route path="/tor" exact component={LandingPage} />
          <Route path="/sf" exact component={LandingPageSF} />
          <Route path="/ott" exact component={LandingPageOTT} />
          <Route path="/la" exact component={LandingPageLA} />
          <Route path="/contact" exact component={GeoRouter} />
          <Route
            path="/tor/contact"
            exact
            component={NewContact}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/tor/contact/email"
            exact
            component={ContactEmail}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/tor/contact/call"
            exact
            component={ContactCallRequest}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/ott/contact"
            exact
            component={NewContact}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/ott/contact/email"
            exact
            component={ContactEmail}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/ott/contact/call"
            exact
            component={ContactCallRequest}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/sf/contact"
            exact
            component={NewContact}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/sf/contact/email"
            exact
            component={ContactEmail}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/sf/contact/call"
            exact
            component={ContactCallRequest}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/nyc/contact"
            exact
            component={NewContact}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/nyc/contact/email"
            exact
            component={ContactEmail}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/nyc/contact/call"
            exact
            component={ContactCallRequest}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/la/contact"
            exact
            component={NewContact}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/la/contact/email"
            exact
            component={ContactEmail}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/la/contact/call"
            exact
            component={ContactCallRequest}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route path="/faq" exact component={GeoRouter} />
          <Route
            path="/sf/faq"
            exact
            component={GeneralFaq}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/tor/faq"
            exact
            component={GeneralFaq}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/ott/faq"
            exact
            component={GeneralFaq}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/nyc/faq"
            exact
            component={GeneralFaq}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/la/faq"
            exact
            component={GeneralFaq}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/downloadapp"
            exact
            component={MobileLandingPage}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/loginapp"
            exact
            component={MobileLandingPage}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route path="/i/:refCode" exact component={Invite} />
          <Route path="/mlogin" component={MagicLogin} />
          <Route
            path="/changesFAQ"
            exact
            component={ChangesFaq}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route
            path="/nyc-dmv-issue"
            exact
            component={NycDmvIssue}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          {/* <Route path="/nyc/go" component={AutzuGo} /> */}
          <Route path="/tor/uber" component={UberToronto} />
          <Route path="/upload" component={MissingDocs} />
          <Route path="/promotions" exact component={Promotion} />
          <Route path="/tor/careers" exact component={Careers} />
          <Route path="/nyc/careers" exact component={Careers} />
          <Route path="/sf/careers" exact component={Careers} />
          <Route path="/la/careers" exact component={Careers} />
          <Route path="/ott/careers" exact component={Careers} />
          {/* <Route path="/investors" exact component={Investors} /> */}
          {/* <Route path="/newsroom" exact component={Newsroom} /> */}
          <Route path="/blogs" exact component={GeoRouter} />
          <Route path="/:region/blogs" exact component={Blogs} />
          <Route path="/:region/blogs/:id" exact component={BlogPage} />
          <Route
            path="/:region/blogs/:id/edit"
            exact
            component={EditBlogIndex}
          />
          <Route path="/:region/newblog" exact component={CreateBlog} />]{' '}
          <Route path="/aboutus" exact component={GeoRouter} />
          <Route
            path="/:region/aboutus"
            exact
            component={AboutUs}
            onUpdate={() => window.scrollTo(0, 0)}
          />
          <Route path="/videos" exact component={GeoRouter} />
          <Route path="/:region/videos" exact component={GeoRouterVideo} />
          <Route
            path="/:region/videos/signup"
            exact
            component={GeoRouterSingleVideo}
          />
          <Route
            path="/:region/videos/bookingandpricing"
            exact
            component={GeoRouterSingleVideo}
          />
          <Route
            path="/:region/videos/beforebooking"
            exact
            component={GeoRouterSingleVideo}
          />
          <Route
            path="/:region/videos/duringbooking"
            exact
            component={GeoRouterSingleVideo}
          />
          <Route
            path="/:region/videos/maximizingearnings"
            exact
            component={GeoRouterSingleVideo}
          />
          <Route
            path="/:region/videos/endingbooking"
            exact
            component={GeoRouterSingleVideo}
          />
          {/* <Route
            path="/goal"
            exact
            component={GoalVision}
            onUpdate={() => window.scrollTo(0, 0)}
          /> */}
          {/* <Route path="/articles" exact component={AllArticles} /> */}
          <Route path="/mediakit" exact component={MediaKit} />
          <Route path="/tor/ev" exact component={AutzuEv} />
          <Route path="/sf/ev" exact component={AutzuEvSF} />
          <Route path="/la/ev" exact component={AutzuEvSF} />
          <Route path="/nyc/ev" exact component={AutzuEvSF} />
          <Route path="/ott/ev" exact component={AutzuEv} />
          <AuthRoute path="/banking-info" exact component={BankingInfo} />
          <AuthRoute path="/hst" exact component={HstNumber} />
          <AuthRoute path="/apply" exact component={MobileLandingPage} />
          <AuthRoute
            path="/applyMobile"
            exact
            component={MobileLandingPage}
          />
          <AuthRoute path="/pricing" exact component={PriceMap} />
          <AuthRoute path="/book" exact component={MobileLandingPage} />
          <AuthRoute path="/oldbook" exact component={Book} />
          {/* <AuthRoute
            path="/dashboard"
            exact
            component={MobileLandingPage}
          /> */}
          <AuthRoute path="/intro/:id" exact component={Intro} />
          <AuthRoute
            path="/mybookings"
            exact
            component={MobileLandingPage}
          />
          <AuthRoute
            path="/mybookings/:bookingId"
            exact
            component={MyBookings}
          />
          <AuthRoute path="/course" exact component={NewCourse} />
          <AuthRoute path="/olddashboard" exact component={Dashboard} />
          <AuthRoute
            path="/how-autzu-works"
            exact
            component={NewDriverFaq}
          />
          <AuthRoute path="/driverfaq" exact component={DriverFaq} />
          <AuthRoute path="/rules" exact component={DriverPolicy} />
          <AuthRoute path="/exam" exact component={NewExam} />
          <AuthRoute path="/invite" component={Referral} />
          <AuthRoute path="/myearnings" exact component={NewPayments} />
          {/* <AuthRoute path="/profile" exact component={NewProfile} /> */}
          <Route path="/userpage" exact component={AccountPage} />
          <AuthRoute path="/report" exact component={Report} />
          <AuthRoute path="/verify" exact component={SmsVerification} />
          <Route path="/update-password" exact component={Password} />
          <Route path="/connect" exact component={Connect} />
          <Route path="/*" component={NoMatch} />
        </Switch>
      </Layout>
    </Switch>
  </BrowserRouter>
);

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root.js